import ApiModel from "@/deprecated/models/api_client"

export class BillingInformationModel extends ApiModel {
  constructor(attributes = {}) {
    super("/billing-information", attributes)
  }

  save(attributes = null, options = {}) {
    if (attributes) {
      this.set(attributes)
    }

    // Wrap the data in a billing_information object to match Rails expectations
    const wrappedData = { billing_information: this.attributes }

    const url = this.urlRoot
    const method = 'POST'

    const headers = {
      'Content-Type': 'application/json',
      'X-CSRF-Token': document.querySelector("meta[name='csrf-token']")?.getAttribute("content")
    }

    return fetch(url, {
      method: method,
      headers: headers,
      body: JSON.stringify(wrappedData)
    })
      .then(response => {
        if (response.ok) {
          if (options.success) {
            options.success(this, response)
          }
          return response
        } else {
          throw new Error('Request failed')
        }
      })
      .catch(error => {
        if (options.error) {
          options.error(this, error)
        }
        throw error
      })
  }
}
